import Rekv from "../Rekv";

const benchStore = new Rekv({
  type: "fc",
  fps: 0,
  num: 100,
  count: 0,
  display: true
});

export default benchStore;

let lastTime = Date.now();
let frameCount = 0;
function run() {
  let now = Date.now();
  frameCount++;
  if (now - lastTime > 1000) {
    const fps = Math.round((frameCount * 1000) / (now - lastTime));
    benchStore.setState({ fps });
    lastTime = now;
    frameCount = 0;
  }
  benchStore.setState((s) => ({ count: s.count + 1 }));
  requestAnimationFrame(run);
}
run();
